import clsx from 'clsx';

import MsgCounterIcon from '@components/icons/MsgCounterIcon';

export default function MessageCounterTag({ value, className }) {
  const isValueNew = value === 'NEW';

  return (
    <div
      className={clsx(
        'w-fit flex flex-row items-center gap-1 p-1 rounded-md',
        isValueNew ? 'bg-[#438fe3]/90' : 'bg-[#AC1E2A]',
        isValueNew && 'text-center',
        className,
      )}
    >
      {!isValueNew && <MsgCounterIcon />}
      <span className={'msg-counter-value'}>{value}</span>
    </div>
  );
}
